import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { forPhoneOnly, forDesktopUp, forDesktopDown } from 'src/config/mediaQueries'

export default createUseStyles((theme: Theme) => ({
  header: {
    [forDesktopDown]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    backgroundColor: customColors.background,
    wordBreak: 'break-word',
    display: 'flex',
    alignItems: 'center',
    padding: 16,
    [forDesktopUp]: {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
  },
  iconCont: {
    [forDesktopDown]: {
      height: '56px',
    },
    width: '24px',
    height: '64px',
    flexShrink: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  headingsCont: {
    flex: 1,
    textAlign: 'center',
    margin: '0 16px',
  },
  headingText: {
    [forDesktopDown]: {
      display: 'none',
    },
    ...typography['Lato H5 Bold'],
    backgroundColor: customColors.background,
    textAlign: 'center',
    padding: [24, 8, 32],
  },
  emptyHeadingText: {
    padding: [24, 0, 0],
  },
  emptyHeadingTextNoSpacing: {
    padding: 0,
  },
  mobileHeadingText: {
    [forDesktopUp]: {
      display: 'none',
    },
    display: 'block',
    padding: [16, 16, 24],
  },
  titleInsteadOfProgressBar: {
    padding: [16, 8],
    [forPhoneOnly]: {
      padding: 0,
    },
  },
  emptyMobileHeadingText: {
    padding: [0, 0, 0],
  },
  mobileSubheading: {
    [forDesktopUp]: {
      display: 'none',
    },
    backgroundColor: customColors.background,
    ...typography['Lato Body 1'],
    padding: [0, 16, 24],
    textAlign: 'center',
  },
}))
